import { createTheme, darken, lighten } from '@mui/material/styles'
import themeBase from './themeBase'

// Create a theme instance.
export const darkTheme = createTheme(themeBase(true), {
  palette: {
    mode: 'dark',
    primary: {
      main: '#a0a9bd',
      light: lighten('#a0a9bd', 0.2),
      dark: darken('#a0a9bd', 0.2),
      contrastText: '#fff',
    },
    secondary: {
      main: '#ef9fae',
      light: lighten('#ef9fae', 0.2),
      dark: darken('#ef9fae', 0.2),
    },
    background: {
      default: '#0d1117',
      paper: '#161b22',
    },
    divider: 'rgba(255, 255, 255, 0.07)',
  },
})

export default darkTheme
